module.exports = __webpack_public_path__ + "static/media/IMG_4280.2b58ffc5.PNG";